import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {changeLocation} from '@web/actions/application'
import {ReasonType, ApplyFail} from '@web/core/constants'
import {ROUTER_ORDER_RESULT, ROUTER_ORDER_SHEET} from '@web/core/routes'
import {LanguageType} from '@web/i18n'
import {replace} from '@web/slices/router'

import type {ThunkApi} from '../interfaces'

const resetPageScroll = () => window.scrollTo(0, 0)

/** 주문 완료로 이동에 필요한 처리  */
export const redirectToOrderResult = createAsyncThunk<
    void,
    {
        orderNo: string
    },
    ThunkApi
>('redirectToOrderResult', async ({orderNo}, {dispatch}) => {
    dispatch(
        changeLocation({
            type: 'REPLACE',
            url: `${ROUTER_ORDER_RESULT.FLEA_MARKET}/${orderNo}`, // check escrow
        }),
    )
    resetPageScroll()
})

/** 주문 완료로 이동에 필요한 처리  */
export const redirectToOrderFail = createAsyncThunk<
    void,
    {
        orderProcessNo: Maybe<string>
        failReason: string
        language: LanguageType
    },
    ThunkApi
>('redirectToOrderFail', async ({orderProcessNo, failReason, language}, {dispatch}) => {
    const resultUrl = ROUTER_ORDER_SHEET.FLEA_MARKET.FAIL.getHref()

    dispatch(
        replace(
            failReason === ReasonType.ORDER_PROCESS_ALREADY_STARTED
                ? qs.stringifyUrl({
                      url: `${resultUrl}/${orderProcessNo}/${ApplyFail.ORDER_PROCESS_ALREADY_STARTED}`,
                      query:
                          failReason === ReasonType.ORDER_PROCESS_ALREADY_STARTED
                              ? {
                                    language,
                                }
                              : {},
                  })
                : `${resultUrl}/${orderProcessNo}`,
        ),
    )
    resetPageScroll()
})
